import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Paper,
  Divider
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const RegistrationCancel = () => {
  const navigate = useNavigate();
  
  const handleTryAgain = () => {
    navigate('/signup');
  };
  
  return (
    <Container maxWidth="sm">
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          minHeight: '80vh'
        }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            width: '100%'
          }}
        >
          <CancelIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
          
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Registration Cancelled
          </Typography>
          
          <Typography variant="body1" paragraph align="center">
            Your registration process was cancelled or interrupted before completion.
          </Typography>
          
          <Divider sx={{ width: '100%', my: 2 }} />
          
          <Typography variant="body1" paragraph align="center">
            No charges have been made to your account. You can try again whenever you're ready.
          </Typography>
          
          <Box sx={{ mt: 2, display: 'flex', gap: 2, width: '100%' }}>
            <Button 
              variant="outlined" 
              color="primary" 
              fullWidth
              onClick={() => navigate('/')}
            >
              Back to Home
            </Button>
            
            <Button 
              variant="contained" 
              color="primary" 
              fullWidth
              onClick={handleTryAgain}
            >
              Try Again
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default RegistrationCancel;
